/**
 * Welle 120 — eigene Strich-Icons für die Seite „Rechnungen" (statt Emojis): einfarbig (currentColor), nur Linien,
 * 24er-Raster. <Ico n="kamera" /> · Größe über `gr` (px).
 */
import React from "react";

const PFADE = {
  kamera: <><path d="M4 8h3l1.8-2.5h6.4L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" /><circle cx="12" cy="13" r="3.5" /></>,
  ordner: <path d="M3 7a1 1 0 0 1 1-1h5l2 2h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />,
  hochladen: <path d="M12 16V4m-5 5 5-5 5 5M4 20h16" />,
  klammer: <path d="M20 11.5 12 19.5a5 5 0 0 1-7-7l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7L9.7 17.2a1.7 1.7 0 0 1-2.4-2.4L15 7" />,
  uhr: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  klemmbrett: <><rect x="5" y="4" width="14" height="17" rx="1.5" /><path d="M9 4V3h6v1M8.5 10h7M8.5 14h7M8.5 18h4" /></>,
  globus: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.6 2.8 2.6 15.2 0 18M12 3c-2.6 2.8-2.6 15.2 0 18" /></>,
  aktualisieren: <path d="M20 12a8 8 0 1 1-2.3-5.6M20 4v5h-5" />,
  speichern: <><path d="M5 4h11l3 3v13H5z" /><path d="M8 4v5h7V4" /><rect x="8" y="14" width="8" height="6" /></>,
  hoch: <path d="M12 19V5m-6 6 6-6 6 6" />,
  runter: <path d="M12 5v14m-6-6 6 6 6-6" />,
  links: <path d="M19 12H5m6-6-6 6 6 6" />,
  rechts: <path d="M5 12h14m-6-6 6 6-6 6" />,
  kopie: <><rect x="8" y="8" width="12" height="12" rx="1.5" /><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3" /></>,
  schliessen: <path d="M6 6l12 12M18 6 6 18" />,
  plus: <path d="M12 5v14M5 12h14" />,
  absatz: <path d="M4 6h16M4 10h16M4 14h10M4 18h7" />,
  dokument: <><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4M9 12h6M9 16h6" /></>,
  bild: <><rect x="3" y="5" width="18" height="14" rx="1.5" /><circle cx="8.5" cy="10" r="1.5" /><path d="M21 16l-5-5-8 8" /></>,
  beleg: <path d="M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6" />,
  diagramm: <path d="M3 20h18M6 17v-5M11 17V7M16 17v-8" />,
  haken: <path d="M5 12.5 10 17.5 19 7" />,
  warnung: <><path d="M12 3 2 20h20z" /><path d="M12 10v4M12 17v.5" /></>,
  verbinden: <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />,
  suche: <><circle cx="11" cy="11" r="6.5" /><path d="M16 16l5 5" /></>,
  stift: <path d="M4 20h4L19 9l-4-4L4 16zM14 6l4 4" />,
  warten: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5h4" /></>,
};

export default function Ico({ n, gr = 16, className = "", titel }) {
  return (
    <svg className={`ico ${className}`} width={gr} height={gr} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden={titel ? undefined : "true"} role={titel ? "img" : undefined}>
      {titel && <title>{titel}</title>}
      {PFADE[n] || PFADE.dokument}
    </svg>
  );
}
